export const tl = (n) => (Number(n) || 0).toLocaleString("tr-TR", { style: "currency", currency: "TRY" });
export const itemPairs = (it) => (Number(it.koli) || 0) * (Number(it.pairs) || 8);
export const itemAmount = (it) => itemPairs(it) * (Number(it.price) || 0);
export const orderAmount = (o) => o.items.reduce((a, it) => a + itemAmount(it), 0);
export const orderPairs = (o) => o.items.reduce((a, it) => a + itemPairs(it), 0);
export const discountRate = (o) => (Number(o.discount_pct) || 0) / 100;
export const orderTotals = (o) => {
  const subtotal = orderAmount(o);
  const discount = subtotal * discountRate(o);
  const net = subtotal - discount;
  const vat = net * ((o.vat_pct ?? 10) === "" ? 0 : Number(o.vat_pct ?? 10) || 0) / 100;
  return { subtotal, discount, net, vat, grand: net + vat };
};
